import { css } from "@emotion/css";
import { Spacing } from "@snapchat/snap-design-system";

export const fullWidthStyle = css`
    width: 100%;
`;

export const fullSizeInputStyle = css`
    flex-basis: 100%;
`;

export const tagContainerSpacingBottom = css`
    margin-bottom: ${Spacing.SM}px;
`;

export const buttonWithError = css`
    margin-bottom: 20px;
`;
